import { render, staticRenderFns } from "./FunnelLiabilitySitecore.vue?vue&type=template&id=51922284"
import script from "./FunnelLiabilitySitecore.vue?vue&type=script&lang=js"
export * from "./FunnelLiabilitySitecore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports